module.exports = __webpack_public_path__ + "static/media/EnrolledOrganizationError.8b97cbef.svg";